<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="功能名称" prop="name" :error="formErrorMsg.name" class="fb-form-item">
                <el-input v-model="formData.name"></el-input>
            </el-form-item>


            <el-form-item label="功能类型" prop="type">

                <dict-select type-flag="ACTION_TYPE" v-model="formData.type"></dict-select>

            </el-form-item>

            <el-form-item label="所属模块" prop="moduleCode" class="fb-form-item">
                <module-cascader v-model="formData.moduleCode"></module-cascader>
            </el-form-item>

            <el-form-item label="开放功能" prop="open" class="fb-form-item">
                <el-select v-model="formData.open" placeholder="是否开放权限">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="功能状态" prop="status" class="fb-form-item">
                <el-select v-model="formData.status" placeholder="请选择用户状态">
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                </el-select>
            </el-form-item>


            <el-form-item label="关联权限" prop="ruleCodes">
                <rule-choose-box v-model="formData.ruleCodes"></rule-choose-box>
            </el-form-item>



            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    import ModuleCascader from "../../components/ModuleCascader";
    import RuleChooseBox from "../../components/rule-choose-box/RuleChooseBox";
    import DictSelect from "../../components/DictSelect";
    export default {
        name: "RoleAdd",
        components: {DictSelect, RuleChooseBox, ModuleCascader},
        data() {
            return {
                api:{
                    add:this.$api.action.add
                },
                formErrorMsg:{name: '',
                    flag: ''},
                formData: {
                    name: '',
                    open: '1',
                    moduleCode: '',
                    ruleCodes: [],
                    type: '1',
                    status: '1',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入功能名称', trigger: 'blur'},
                    ],
                    flag: [
                        {required: true, message: '请输入功能标识', trigger: 'blur'},
                    ],
                    moduleCode: [
                        {required: true, message: '请选择功能所属模块', trigger: 'blur'},
                    ],
                    status: [
                        {required: true, message: '请选择功能状态', trigger: 'blur'},
                    ]

                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.add,this.formData).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){

                                console.log(vm.$refs[form]);


                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(()=>{
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if(resp.data.desc){
                                    vm.$message({
                                        type:"error",
                                        message: resp.data.desc
                                    });
                                }


                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {
            let vm = this;

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

</style>